import { render, staticRenderFns } from "./IngestingTable.vue?vue&type=template&id=6d1c121a&scoped=true&"
import script from "./IngestingTable.vue?vue&type=script&lang=js&"
export * from "./IngestingTable.vue?vue&type=script&lang=js&"
import style0 from "./IngestingTable.vue?vue&type=style&index=0&id=6d1c121a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c121a",
  null
  
)

export default component.exports